import IndexSidebar from 'flarum/forum/components/IndexSidebar';
import Page from 'flarum/common/components/Page';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import extractText from 'flarum/common/utils/extractText';
import MatchesTab from './MatchesTab';
import MyPicksTab from './MyPicksTab';
import LeaderboardTab from './LeaderboardTab';
export default class PickemPage extends Page {
  activeTab = 'matches';
  loading = true;
  picks = {};
  myPicksLoading = false;
  myPicksHasMore = false;
  userScores = [];
  leaderboardLoading = false;
  leaderboardHasMore = false;

  // YENİ: Kendi skorunu tutacak state
  myScore = null;
  filterDataLoaded = false;
  oninit(vnode) {
    super.oninit(vnode);
    if (!app.forum.attribute('pickem.canView')) {
      m.route.set('/');
      return;
    }
    this.activeTab = 'matches';
    this.loading = true;
    this.picks = {};
    this.myPicksLoading = false;
    this.myPicksHasMore = false;
    this.userScores = [];
    this.leaderboardLoading = false;
    this.leaderboardHasMore = false;
    this.myScore = null;
    this.filterDataLoaded = false;
    this.loadInitialData();
  }
  oncreate(vnode) {
    super.oncreate(vnode);
    app.setTitle(extractText(app.translator.trans('huseyinfiliz-pickem.lib.nav.pickem')));
  }
  async loadInitialData() {
    try {
      const promises = [];
      if (app.session.user && app.forum.attribute('pickem.makePicks')) {
        promises.push(this.loadPicks(0));
        // YENİ: Eğer giriş yapmışsa kendi sıralamasını çek
        promises.push(this.loadMyRank());
      }
      promises.push(this.loadLeaderboard(0));
      promises.push(this.loadFilterData());
      await Promise.all(promises);
    } catch (error) {
      console.error('Error loading initial data:', error);
    } finally {
      this.loading = false;
      this.filterDataLoaded = true;
      m.redraw();
    }
  }

  // YENİ: Kendi sıralamasını çeken fonksiyon
  async loadMyRank() {
    if (!app.session.user) return;
    try {
      // ListLeaderboardController'a eklediğimiz 'user' filtresini kullanıyoruz
      const results = await app.store.find('pickem-user-scores', {
        filter: {
          user: app.session.user.id()
        },
        page: {
          limit: 1
        }
      });
      if (results && results.length > 0) {
        this.myScore = results[0];
      }
    } catch (error) {
      console.error('Error loading my rank:', error);
    }
  }
  async loadPicks(offset = 0) {
    if (!app.session.user || !app.forum.attribute('pickem.makePicks')) return;
    this.myPicksLoading = true;
    m.redraw();
    const limit = 20;
    try {
      const results = await app.store.find('pickem-picks', {
        filter: {
          user: app.session.user.id()
        },
        include: 'event,event.homeTeam,event.awayTeam',
        page: {
          offset,
          limit
        }
      });
      if (results && Array.isArray(results)) {
        const newPicksMap = results.reduce((acc, pick) => {
          try {
            const event = pick && (typeof pick.event === 'function' ? pick.event() : pick.event);
            if (event && typeof event.id === 'function') {
              acc[String(event.id())] = pick;
            }
          } catch (err) {
            console.warn('Invalid pick:', err);
          }
          return acc;
        }, {});
        this.picks = {
          ...this.picks,
          ...newPicksMap
        };
        this.myPicksHasMore = results.length >= limit;
      }
    } catch (error) {
      console.error('Error loading picks:', error);
    } finally {
      this.myPicksLoading = false;
      m.redraw();
    }
  }
  async loadLeaderboard(offset = 0) {
    this.leaderboardLoading = true;
    m.redraw();
    const limit = 20;
    try {
      const results = await app.store.find('pickem-user-scores', {
        include: 'user',
        page: {
          offset,
          limit
        }
      });
      if (offset === 0) {
        this.userScores = results;
      } else {
        this.userScores.push(...results);
      }
      this.leaderboardHasMore = results.length >= limit;
    } catch (error) {
      console.error('Error loading leaderboard:', error);
    } finally {
      this.leaderboardLoading = false;
      m.redraw();
    }
  }
  async loadFilterData() {
    try {
      await Promise.all([app.store.find('pickem-public-seasons'), app.store.find('pickem-public-teams'), app.store.find('pickem-public-weeks')]);
    } catch (error) {
      console.error('Error loading filter data:', error);
    }
  }
  view() {
    return m("div", {
      className: "IndexPage PickemPage"
    }, m("header", {
      className: "Hero PickemHero"
    }, m("div", {
      className: "container"
    }, m("div", {
      className: "containerNarrow"
    }, m("h1", {
      className: "Hero-title"
    }, m("i", {
      className: "icon fas fa-trophy"
    }), " ", app.translator.trans('huseyinfiliz-pickem.lib.nav.pickem'))))), m("div", {
      className: "container"
    }, m("div", {
      className: "sideNavContainer"
    }, m(IndexSidebar, null), m("div", {
      className: "IndexPage-results sideNavOffset"
    }, m("div", {
      className: "PickemPage-tabs"
    }, this.renderTab('matches', app.translator.trans('huseyinfiliz-pickem.lib.nav.matches')), app.session.user && app.forum.attribute('pickem.makePicks') && this.renderTab('my_picks', app.translator.trans('huseyinfiliz-pickem.lib.nav.my_picks')), this.renderTab('leaderboard', app.translator.trans('huseyinfiliz-pickem.lib.nav.leaderboard'))), this.loading ? m(LoadingIndicator, null) : m("div", {
      className: "PickemPage-tabContent"
    }, this.renderAllTabs())))));
  }
  renderTab(tabId, label) {
    const active = this.activeTab === tabId;
    return m("button", {
      className: `Button Button--flat PickemPage-tab ${active ? 'active' : ''}`,
      onclick: () => {
        this.activeTab = tabId;
      }
    }, label);
  }
  renderAllTabs() {
    return m('[', null, m("div", {
      className: `PickemPage-tabPane ${this.activeTab === 'matches' ? 'active' : ''}`
    }, this.filterDataLoaded && m(MatchesTab, {
      picks: this.picks,
      onPickChange: picks => {
        this.picks = picks;
      }
    })), app.session.user && app.forum.attribute('pickem.makePicks') && m("div", {
      className: `PickemPage-tabPane ${this.activeTab === 'my_picks' ? 'active' : ''}`
    }, m(MyPicksTab, {
      picks: this.picks,
      loading: this.myPicksLoading,
      hasMore: this.myPicksHasMore,
      onLoadMore: () => this.loadPicks(Object.keys(this.picks).length)
    })), m("div", {
      className: `PickemPage-tabPane ${this.activeTab === 'leaderboard' ? 'active' : ''}`
    }, m(LeaderboardTab, {
      userScores: this.userScores
      // YENİ: myScore'u gönderiyoruz
      ,
      myScore: this.myScore,
      hasMore: this.leaderboardHasMore,
      loading: this.leaderboardLoading,
      onLoadMore: () => this.loadLeaderboard(this.userScores.length)
    })));
  }
}
flarum.reg.add('huseyinfiliz-pickem', 'forum/components/PickemPage', PickemPage);